import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface AuthUser {
  id: string
  name: string
  email: string
  role: string
}

export interface AuthState {
  user: AuthUser | null
  token: string | null
  setAuth: (user: AuthUser, token: string) => void
  clearAuth: () => void
}

/**
 * Zustand auth store, persisted in localStorage under `sdr-agend-auth`.
 *
 * NOTE (security): JWT in localStorage is exposed to XSS. Accepted for MVP per
 * Story 1.3 / CodeRabbit HIGH note — to be revisited in Story 1.7 (real auth).
 */
export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      setAuth: (user, token) => set({ user, token }),
      clearAuth: () => set({ user: null, token: null }),
    }),
    { name: 'sdr-agend-auth' },
  ),
)
